import { MultiSelectWithCheckboxes } from '@src/components/ui';

interface MultiSelectProps {
    field: {
        value: { value: string; label: string }[];
        onChange: (val: { value: string; label: string }[]) => void;
    };
    options: { value: string; label: string }[];
    hasMore?: boolean;
    loading: boolean;
    placeholder: string;
    allowClear?: boolean;
    disabled?: boolean;
    size?: 'small' | 'middle' | 'large';
    loadMore?: () => void;
    onClear?: () => void;
    onSearch?: (val: string) => void;
    className?: string;
    maxLength?: number;
    selectedItemClassName?: string;
}

export const MultiSelect = ({
    field,
    options,
    hasMore,
    loading,
    placeholder,
    allowClear,
    disabled,
    size,
    loadMore,
    onClear,
    onSearch,
    className,
    maxLength,
    selectedItemClassName,
}: MultiSelectProps) => {
    const { value, onChange } = field;

    return (
        <MultiSelectWithCheckboxes
            size={size || 'large'}
            loading={loading}
            options={options}
            value={Array.isArray(value) ? value : []}
            onChange={onChange}
            placeholder={placeholder}
            disabled={(loading && options.length === 0) || disabled}
            hasMore={hasMore}
            allowClear={allowClear ?? true}
            onLoadMore={loadMore}
            onSearch={onSearch}
            onClear={onClear}
            className={className}
            maxLength={maxLength}
            selectedItemClassName={selectedItemClassName}
        />
    );
};
